import React, { useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { toast } from 'react-toastify';
import { PaymentServiceWithVersionsResponseType } from '../../../../../../../api/types/payments/payment-template';
import { PaymentServicesTable } from '../../../../../../../pages/payments/tabs/componenets/payment-services-table';
import { SelectedCrmCatalogService } from './crm-payment-service-item.type';

interface SelectCrmPaymentServiceDialogProps {
  visible: boolean;
  onHide: () => void;
  onSelect: (service: SelectedCrmCatalogService) => void;
}

export const SelectCrmPaymentServiceDialog: React.FC<
  SelectCrmPaymentServiceDialogProps
> = ({ visible, onHide, onSelect }) => {
  const [selectedService, setSelectedService] =
    useState<PaymentServiceWithVersionsResponseType | null>(null);

  // Remount the shared PaymentServicesTable so filter / pagination reset on open.
  const [tableKey, setTableKey] = useState(0);

  useEffect(() => {
    if (visible) {
      setSelectedService(null);
      setTableKey((k) => k + 1);
    }
  }, [visible]);

  const handleApprove = () => {
    if (!selectedService) return;

    const latestPrice = selectedService.versions[0];
    if (!latestPrice) {
      toast.warn('לשירות שנבחר אין גרסת מחיר');
      return;
    }

    onSelect({
      paymentServiceId: selectedService.id,
      paymentServicePriceId: latestPrice.id,
      serviceName: selectedService.paymentServiceName,
      unitPrice: latestPrice.price,
    });
    onHide();
  };

  const isApproveDisabled = !selectedService;

  return (
    <Dialog
      header="בחירת שירות תשלום"
      visible={visible}
      onHide={onHide}
      style={{ width: '800px', direction: 'rtl' }}
      modal
    >
      <PaymentServicesTable
        key={tableKey}
        selectionMode="single"
        selectedService={selectedService}
        onSingleSelectionChange={setSelectedService}
      />

      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-end',
          marginTop: '20px',
          paddingBottom: '10px',
          gap: '0.5rem',
        }}
      >
        <Button label="ביטול" onClick={onHide} severity="secondary" text />
        <Button
          label="אישור"
          onClick={handleApprove}
          tooltip={
            isApproveDisabled
              ? 'יש לבחור שירות תשלום לפני האישור'
              : 'הוספת שירות לתשלום'
          }
          tooltipOptions={{ showOnDisabled: true }}
          disabled={isApproveDisabled}
        />
      </div>
    </Dialog>
  );
};
